class CtlVariantPicker extends HTMLElement {
  connectedCallback() {
    this._variantInput = this.querySelector('.ctl-variant-id');
    this._addBtn = this.querySelector('.ctl-add-btn');
    this._trigger = this.querySelector('.ctl-dropdown__trigger');
    this._list = this.querySelector('.ctl-dropdown__list');
    this._label = this.querySelector('.ctl-dropdown__label');
    this._options = this.querySelectorAll('.ctl-dropdown__option');
    this._hasMultipleVariants = this._trigger !== null;

    if (this._hasMultipleVariants) {
      // No variant pre-selected — disable Add until one is chosen
      this._addBtn.disabled = true;
      this._variantInput.value = '';

      // Move list to body so it escapes overflow clipping from the carousel
      document.body.appendChild(this._list);

      this._trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this._toggleDropdown();
      });

      this._options.forEach(option => {
        option.addEventListener('click', () => this._selectVariant(option));
      });

      // Close on outside click
      this._outsideClickHandler = (e) => {
        if (!this.contains(e.target) && !this._list.contains(e.target)) {
          this._closeDropdown();
        }
      };
      document.addEventListener('click', this._outsideClickHandler);

      // Reposition on scroll/resize
      this._repositionHandler = () => {
        if (!this._list.hidden) this._positionList();
      };
      window.addEventListener('scroll', this._repositionHandler, { passive: true });
      window.addEventListener('resize', this._repositionHandler, { passive: true });
    }

    // Guard: intercept submit if no variant selected yet
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        if (this._hasMultipleVariants && !this._variantInput.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          this._openDropdown();
        }
      });
    }
  }

  disconnectedCallback() {
    if (this._outsideClickHandler) {
      document.removeEventListener('click', this._outsideClickHandler);
    }
    if (this._repositionHandler) {
      window.removeEventListener('scroll', this._repositionHandler);
      window.removeEventListener('resize', this._repositionHandler);
    }
    // Return list to component if it was moved
    if (this._list && this._list.parentNode === document.body) {
      document.body.removeChild(this._list);
    }
  }

  _toggleDropdown() {
    this._list.hidden ? this._openDropdown() : this._closeDropdown();
  }

  _positionList() {
    const rect = this._trigger.getBoundingClientRect();
    this._list.style.top = `${rect.bottom + window.scrollY + 2}px`;
    this._list.style.left = `${rect.left + window.scrollX}px`;
    this._list.style.width = `${rect.width}px`;
  }

  _openDropdown() {
    this._positionList();
    this._list.hidden = false;
    this._trigger.setAttribute('aria-expanded', 'true');
  }

  _closeDropdown() {
    this._list.hidden = true;
    this._trigger.setAttribute('aria-expanded', 'false');
  }

  _selectVariant(option) {
    if (option.dataset.available !== 'true') return;

    this._variantInput.value = option.dataset.variantId;
    this._label.textContent = option.dataset.variantTitle;
    this._addBtn.disabled = false;

    // Mark selected
    this._options.forEach(o => o.setAttribute('aria-selected', 'false'));
    option.setAttribute('aria-selected', 'true');

    this._closeDropdown();
  }
}

if (!window.customElements.get('ctl-variant-picker')) {
  window.customElements.define('ctl-variant-picker', CtlVariantPicker);
}
